class TwitterCustomSearch {
  constructor(id, accountId, search) {
    this._id = { $oid: id };
    this.accountId = accountId;
    this.search = search;
  }
}

export default TwitterCustomSearch;
